import { useEffect } from 'react'
import { NavigationType, useLocation, useNavigationType } from 'react-router-dom'

type Props = {
  children?: JSX.Element | JSX.Element[]
  containerId: string
}

function useBackButton() {
  const navType = useNavigationType()
  return navType === NavigationType.Pop
}

export default function ScrollToTop({ children, containerId }: Props) {
  const { pathname } = useLocation()

  const isPop = useBackButton()
  
  useEffect(() => {
    if (isPop) {
      return
    }
    document.getElementById(containerId)?.scrollTo(0, 0)
  }, [pathname, isPop, containerId])
  
  return (
    <>
      {
        children
      }
    </>
  )
}